import {defineStore} from 'pinia'
import {useApiRequestStore} from '../../ApiRequestStore/useApiRequestStore'
import {useWorkspaceStore} from '@toolify/client/src/stores/WorkspaceStore/useWorkspaceStore'
import {
  IGlobalSearchRequestInterfaces,
} from '@toolify/server/src/controllers/GlobalSearchController/validators/Search/types/IGlobalSearchRequestInterfaces'
import {IGlobalSearchResultItem} from '@toolify/server/src/controllers/GlobalSearchController/types/IGlobalSearchResultItem'

export const useGlobalSearchApiStore = defineStore('globalSearchApiStore', {
  actions: {
    async search(
      query: string,
      limit?: number,
      offset?: number,
    ): Promise<IGlobalSearchRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const workspaceStore = useWorkspaceStore()
      const workspaceId = workspaceStore.currentWorkspace.id
      const {results} = await apiRequestStore.get<IGlobalSearchRequestInterfaces>(
        `/workspace/${workspaceId}/global-search`,
        {
          params: {
            query,
            limit,
            offset,
          },
        },
      )
      return {
        results: results as unknown as IGlobalSearchResultItem[],
      }
    },
  },
})
